import { all, takeEvery } from 'redux-saga/effects';

import EntryActionTypes from '../../../constants/EntryActionTypes';
import services from '../services';

export default function* contentTypesWatchers() {
  yield all([
    takeEvery(EntryActionTypes.CONTENT_TYPE_TEMPLATES_FETCH, () =>
      services.fetchContentTypeTemplates(),
    ),
    takeEvery(EntryActionTypes.CONTENT_TYPE_TEMPLATE_CREATE, ({ payload: { data } }) =>
      services.createContentTypeTemplate(data),
    ),
    takeEvery(EntryActionTypes.CONTENT_TYPE_TEMPLATE_UPDATE, ({ payload: { id, data } }) =>
      services.updateContentTypeTemplate(id, data),
    ),
    takeEvery(EntryActionTypes.CONTENT_TYPE_TEMPLATE_DELETE, ({ payload: { id } }) =>
      services.deleteContentTypeTemplate(id),
    ),
    takeEvery(
      EntryActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_CREATE,
      ({ payload: { templateId, data } }) => services.createContentTypeTemplateItem(templateId, data),
    ),
    takeEvery(
      EntryActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_UPDATE,
      ({ payload: { id, data } }) => services.updateContentTypeTemplateItem(id, data),
    ),
    takeEvery(EntryActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_DELETE, ({ payload: { id } }) =>
      services.deleteContentTypeTemplateItem(id),
    ),
    takeEvery(EntryActionTypes.CONTENT_TYPES_IN_CURRENT_BOARD_FETCH, () =>
      services.fetchContentTypesInCurrentBoard(),
    ),
    takeEvery(EntryActionTypes.CONTENT_TYPE_IN_CURRENT_BOARD_CREATE, ({ payload: { data } }) =>
      services.createContentTypeInCurrentBoard(data),
    ),
    takeEvery(EntryActionTypes.CONTENT_TYPE_UPDATE, ({ payload: { id, data } }) =>
      services.updateContentType(id, data),
    ),
    takeEvery(EntryActionTypes.CONTENT_TYPE_DELETE, ({ payload: { id } }) =>
      services.deleteContentType(id),
    ),
    takeEvery(
      EntryActionTypes.CONTENT_TYPE_TEMPLATE_IN_CURRENT_BOARD_APPLY,
      ({ payload: { templateId } }) => services.applyContentTypeTemplateInCurrentBoard(templateId),
    ),
  ]);
}
